// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pf-breadcrumb nav a{text-decoration:none !important}.pf-breadcrumb nav a:hover,.pf-breadcrumb nav a:focus-visible{text-decoration:underline !important}.pf-breadcrumb:not(.instance-home-breadcrumb){padding-bottom:var(--space-static-xxs-cu8i4u, 4px);margin-bottom:var(--space-static-m-ez4bsi, 16px);border-bottom:1px solid var(--color-border-divider-default-n6fu48, #eaeded)}", ""]);
// Exports
module.exports = exports;
